<template>
  <div class="message-preview__container">
    <div class="message-preview-icon__container">
      <span class="message-preview-icon__icon">
        <em class="fas fa-envelope iconNav2" />
      </span>
      <p
        @click="handleViewMore"
        class="message-preview-icon__more-action"
      >
        Leer más
      </p>
    </div>
    <div class="message-preview-detail__container">
      <p class="message-preview-detail__title">
        {{ value.titleDescription }}
        <span class="message-preview-detail__text" style="width: 150px; width: 150px; text-align: end;">
          {{ $formatDate(value.createDate, $templateDate.hourWithWeekDay) }}
        </span>
      </p>
      <p class="message-preview-detail__text">{{ value.messageShortDescription }}</p>
      <div class="message-preview-detail__actions">
        <action-button
          text="Ver Enlace"
          v-if="value.link"
          i="fas fa-link"
          class="text-green"
          variant="custom-prev"
          @click="handleViewLink"
        />
        <action-button
          text="Descargar"
          v-if="value.documentId"
          i="fas fa-file-download"
          class="text-green"
          variant="custom-prev"
          @click="handleDownloadFile"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import alert from '@/mixins/alert.mixin';
import generalService from '@/services/pei/general';

export default {
  name: 'MessagePreview',
  mixins: [alert],
  components: {
    ActionButton
  },
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({
        messageId: null,
        titleDescription: null,
        messageShortDescription: null,
        createDate: null,
        documentId: null,
        link: null,
      }),
    }
  },
  data() {
    return {
    };
  },
  methods: {
    handleViewMore() {
      this.$router.push({
        name: 'message',
        params: { 
          messageId: this.value.messageId
        }
      });
    },
    handleDownloadFile() {
      return generalService.downloadDocumentByAttachmentId(this.value.documentId);
    },
    handleViewLink() {
      alert.methods.ShowAlertModal(
        'Enlace',
        this.value.link,
        'link'
      );
    }
  }
};
</script>

<style scoped>
.message-preview__container {
  min-height: 160px;
  display: flex;
  margin: 7px;
  padding: 10px;
  border-radius: 4px;
  background: #FFF;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.10);
}

.message-preview-icon__container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-right: 20px;
  width: 80px;
}

.message-preview-icon__icon {
  padding: 15px 0;
  display: flex;
  justify-content: center;
  border-radius: 4px;
  background: rgba(45, 183, 130, 0.25);
}

.message-preview-icon__more-action {
  font-weight: bold;
  cursor: pointer;
}

.message-preview-detail__container {
  width: 100%;
}

.message-preview-detail__title {
  display: flex;
  font-weight: bold;
  justify-content: space-between;
}

.message-preview-detail__title > span {
  font-weight: normal;
  font-size: 14px;
}

.message-preview-detail__text {
  color: #727272;
  font-style: normal;
  line-height: normal;
}

.message-preview-detail__actions {
  display: flex;
  justify-content: flex-end;
}
</style>